export default {
  'pages.userCenter.breadcrumb.home': 'Home',
  'pages.userCenter.name': 'User Center',
  'pages.userCenter.oc.name': 'My Order',
  'pages.userCenter.oc.intention': 'Intention Order List',
  'pages.userCenter.oc.order': 'Order List',
  'pages.userCenter.cc.name': 'Collection Center',
  'pages.userCenter.cc.collect': 'Collection',
  'pages.userCenter.ac.name': 'Account Setting',
  'pages.userCenter.ac.account.name': 'Account',
  'pages.userCenter.ac.security.name': 'Account Security',
  'pages.userCenter.notification.name': 'Notification',
  'pages.userCenter.notification.platform.name': 'Platform Notification',
  'pages.userCenter.notification.filter.7days': '7 Days',
  'pages.userCenter.notification.filter.30days': '30 Days',
  'pages.userCenter.notification.filter.all': 'All',
  'pages.userCenter.notification.download': 'Download',
  'pages.userCenter.notification.more': 'More',
  'pages.userCenter.collection.name': 'Collect Goods',
  'pages.userCenter.collection.time.label': 'Date',
  'pages.userCenter.collection.goods.detail': 'Details',
  'pages.userCenter.collection.goods.cancelCollect': 'Cancel Collect',
};
